import { createUseStyles } from 'react-jss'
import { WHITE } from '@omnilert/components'
export default createUseStyles({
  '@keyframes spinAround': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(359deg)' }
  },
  baseButtonContainer: ({ disabled }) => ({
    position: 'relative',
    height: '90px',
    width: '90px',
    margin: '5px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.2 : 1,
    pointerEvents: disabled && 'none',
    '&:hover': {
      cursor: disabled ? 'not-allowed' : 'pointer'
    }
  }),
  outterBorder: ({ backgroundColor }) => ({
    backgroundColor: 'var(--primary__page__background)',
    borderRadius: '50%',
    borderStyle: 'solid',
    borderColor: backgroundColor,
    borderWidth: '3px',
    height: '84px',
    position: 'absolute',
    textDecoration: 'none',
    width: '84px',
    zIndex: 1,
    pointerEvents: 'none'
  }),
  roundedButton: ({ backgroundColor, primaryButtonTextColor }) => ({
    backgroundColor,
    color: primaryButtonTextColor,
    alignItems: 'center',
    border: '2px solid var(--primary__page__background)',
    borderRadius: '50%',
    display: 'flex',
    height: '80px',
    left: '3px',
    padding: 0,
    position: 'absolute',
    textAlign: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    top: '3px',
    width: '80px',
    zIndex: 2,
    pointerEvents: 'none'
  }),
  title: {
    fontSize: '18px',
    fontWeight: 'bold !important',
    pointerEvents: 'none'
  },
  isLoading: {
    color: 'transparent !important',
    pointerEvents: 'none',
    '&:after': {
      animation: '$spinAround 500ms infinite linear',
      border: ['2px', 'solid', WHITE],
      borderRadius: '290486px',
      borderRightColor: ['transparent', '!important'],
      borderTopColor: ['transparent', '!important'],
      content: '""',
      display: 'block',
      height: '1em',
      left: 'calc(50% - (1em/2))',
      position: 'absolute !important',
      top: 'calc(50% - (1em/2))',
      width: '1em',
      zIndex: 10
    }
  }
})

